module.exports = __webpack_public_path__ + "img/titleth.6c55627b.png";